import React, { useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Comment from './Comment';
import { AuthContext } from './App';

import DOMPurify from 'dompurify';

import {
  OfficeBuildingIcon,
  BriefcaseIcon,
  MailIcon,
  TrashIcon,
  LocationMarkerIcon
} from '@heroicons/react/solid';

function JobOfferDetails() {
  const { documentId } = useParams();
  const [jobOffer, setJobOffer] = useState(null);
  const [newComment, setNewComment] = useState("");
  const [sort, setSort] = useState(''); // State to handle sorting
  const [likedByMe, setLikedByMe] = useState(false);
  const [bookmarks, setBookmarks] = useState(new Set());
  const { auth } = useContext(AuthContext);

  useEffect(() => {
    axios.get(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments?sort=${sort}`)
      .then(response => {
        // const updatedJobOffer = {...jobOffer, comments: response.data};
        setJobOffer(response.data);
        setLikedByMe(response.data.likedBy.includes(auth.user));
      })
      .catch(error => console.error('Error fetching comments:', error));
  }, [documentId, sort]);

  useEffect(() => {
    if (auth.isLoggedIn) {
        fetchBookmarks();
    }
}, [auth.isLoggedIn, auth.user]); // Fetch data on currentPage or filters change

  const toggleLike = () => {
    setLikedByMe(!likedByMe);
    axios.post(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/like`, {
      userId: auth.user // Adjust based on user's session or context
    })
    .then(response => {
      setJobOffer({ ...jobOffer, likes: response.data.likes });
      setLikedByMe(response.data.likedByMe);
    })
    .catch(error => console.error('Error toggling like:', error));
  };

  // const addComment = () => {
  //   axios.post(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments`, {
  //     text: newComment,
  //     commenter: 'Anonymous' // This should be replaced with the actual user's name or ID
  //   })
  //   .then(response => {
  //     setJobOffer(prev => ({ ...prev, comments: [...prev.comments, response.data] }));
  //     setNewComment("");
  //   })
  //   .catch(error => console.error('Error posting comment:', error));
  // };

  const addComment = () => {
    axios.post(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments?sort=${sort}`, {
      text: newComment,
      commenter: 'Anonymous'
    })
    .then(response => {
      // Assuming response.data is the updated job offer with the new comment list already sorted
      setJobOffer(response.data);
      setNewComment("");
    })
    .catch(error => console.error('Error posting comment:', error));
  };  
  

  const countAllComments = (comments) => {
    let count = comments.length; // Start with top-level comments
    comments.forEach(comment => {
      count += countAllComments(comment.replies || []); // Recursively count replies
    });
    return count;
  };
  
  // Use this function in your JSX like so:
  
  const fetchBookmarks = async () => {
      try {
          const response = await axios.get(`https://api.finaloffers.fyi/auth/user/${auth.user}/bookmarks`);
          const newBookmarks = new Set(response.data.map(bookmark => bookmark._id.toString()));
          setBookmarks(newBookmarks);
      } catch (error) {
          console.error("Failed to fetch bookmarks:", error);
      }
  };

  const toggleBookmark = async (documentId, e) => {
      e.stopPropagation(); // Prevent card click when clicking the button
      if (!auth.isLoggedIn) {
          alert("Please log in to bookmark jobs.");
          return;
      }
      try {
          await axios.post(`https://api.finaloffers.fyi/auth/toggle-bookmark`, {
              userId: auth.user,
              documentId
          });
          const newBookmarks = new Set(bookmarks);
          if (newBookmarks.has(documentId)) {
              newBookmarks.delete(documentId);
          } else {
              newBookmarks.add(documentId);
          }
          setBookmarks(newBookmarks); // Trigger re-render
      } catch (error) {
          console.error('Failed to toggle bookmark:', error);
      }
  };
  

  return (
    <div>
      {jobOffer ? (
        <div>
          <div className='max-w-screen-md mx-auto items-center justify-center m-4'>
            <div className='grid grid-cols-2 gap-4 mt-4 '>
              <div className="flex flex-col items-center justify-center">
                <div className='text-sm font-semibold mb-3 border-b border-black '>Experience</div>
                <div className='text-lg bg-[#DDD9D0] w-full flex flex-col items-center justify-center py-2'>{jobOffer.experience} Years</div>
              </div>
              <div className="flex flex-col items-center justify-center">
                <div className='text-sm font-semibold border-b border-black mb-3'>Highest Degree</div>
                <div className='text-lg bg-[#DDD9D0] w-full flex flex-col items-center justify-center py-2'>{jobOffer.degree}</div>
              </div>
            </div>
            {jobOffer.offers.map((offer) => (
                  <div key={offer} className='border-black border p-5 my-4'>
                    <div className='grid grid-cols-2 gap-4 mt-2 p-3'>
                      <div className='inline-flex col-span-1'>
                        <OfficeBuildingIcon className="h-9 w-9 ml-3 mr-2" />
                        <div className='text-2xl pt-1'>
                          {offer.company}
                        </div>
                      </div>
                      
                      <div className='flex flex-col items-end col-span-1 pt-1'>
                        {(offer.status === "Accepted") && (
                            <div className="inline-flex text-md mr-5 p-1 text-[#038744]">
                                <div className='pt'>
                                    <i class="fa-solid fa-check-double" style={{color: '#038744'}}>
                                    </i>
                                </div>
                                <div className='pl-1'>{offer.status}</div>
                            </div>
                        )}
                        {(offer.status === "Offered") && (
                            <div className="inline-flex text-md mr-5 text-center p-1 text-[#3681f9]">
                                <div className='pt'>
                                    <i class="fa-solid fa-check" style={{color: '#3c82f6'}}>
                                    {/* <span class="material-icons-outlined">done_all</span> */}
                                    </i>
                                </div>
                                <div className='pl-1'>{offer.status}</div>
                            </div>
                        )}
                        {(offer.status === "Denied") && (
                            <div className="inline-flex text-md mr-5 pt-[0.5px] text-center p-1 text-[#d9544f]">
                                <div className='pt'>
                                    <i class="fa-solid fa-xmark" style={{color: '#d9544f'}}>
                                    {/* <span class="material-icons-outlined">done_all</span> */}
                                    </i>
                                </div>
                                <div className='pl-1'>Denied</div>
                            </div>
                        )}
                      </div>
                    </div>
                    <div className='grid grid-cols-4 gap-4 p-3 pt-3'>
                      <div className="flex flex-col col-span-2">
                        <div className='text-sm font-bold mb-1'>&nbsp;</div>
                        <div className='inline-flex col-span-1 pl-1'>
                          <BriefcaseIcon className="h-6 w-6 ml-4 mr-2" />
                          <div className='text-md pl-1'>
                            {/* {offer.title} */}
                            {offer.title === "Other" ? offer.customTitle : offer.title}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col col-span-1">
                        <div className='text-sm font-bold underline underline-offset-2'>Focus</div>
                        <div className='text-sm rounded-md w-full flex flex-col items-center justify-center py-1'>
                          {(offer.focus?.toLocaleString() || "-")}
                        </div>
                      </div>
                      <div className="flex flex-col col-span-1">
                        <div className='text-sm font-bold underline underline-offset-2'>Level</div>
                        <div className='text-sm rounded-md w-full flex flex-col items-center justify-center py-1'>
                        {(offer.level?.toLocaleString() || "-")}
                        </div>
                      </div>
                    </div>
                    <div className='grid grid-cols-4 gap-4 p-3 pt-0'>
                      <div className="flex flex-col col-span-2">
                        <div className='text-sm font-bold mb-1'>&nbsp;</div>
                        <div className='inline-flex col-span-1 pl-1'>
                          <LocationMarkerIcon className="h-6 w-6 ml-4 mr-2" />
                          <div className='text-md pl-1'>
                            {/* {offer.title} */}
                            {offer.location}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-col col-span-1">
                        <div className='text-sm font-bold mb-1 underline underline-offset-2'>Mode</div>
                        <div className='text-sm rounded-md w-full flex flex-col items-center justify-center py-1'>{offer.workMode}</div>
                      </div>
                      <div className="flex flex-col col-span-1">
                        <div className='text-sm font-bold mb-1 underline underline-offset-2'>Offer Date</div>
                        <div className='text-sm rounded-md w-full flex flex-col items-center justify-center py-1'>
                          {(offer.offerDate?.toLocaleString() || "-")}
                        </div>
                      </div>
                    </div>
                    {offer.status !== "Denied" && offer.salaryDetails && (
                      <>
                        <div className='grid grid-cols-4 gap-4 p-3'>
                          <div className="flex flex-col">
                            <div className='text-sm font-semibold mb-3'>Base Salary</div>
                            <div className='text-lg rounded-md w-full flex flex-col items-center justify-center py-2'>
                              {/* {offer.salaryDetails.baseSalary} */}
                              {(offer.salaryDetails.baseSalary?.toLocaleString('en-US', { style: 'currency', currency: 'USD'}) || "$0")}
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <div className='text-sm font-semibold mb-3'>Average Yearly Stock</div>
                            <div className='text-lg  rounded-md w-full flex flex-col items-center justify-center py-2'>
                              {(offer.salaryDetails.stock?.toLocaleString('en-US', { style: 'currency', currency: 'USD'}) || "$0")}
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <div className='text-sm font-semibold mb-3'>Yearly Target Bonus</div>
                            <div className='text-lg rounded-md w-full flex flex-col items-center justify-center py-2'>
                              {(offer.salaryDetails.targetBonus?.toLocaleString('en-US', { style: 'currency', currency: 'USD'}) || "$0")}
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <div className='text-sm font-semibold mb-3'>Total Sign-On Bonus</div>
                            <div className='text-lg rounded-md w-full flex flex-col items-center justify-center py-2'>
                              {(offer.salaryDetails.signingBonus?.toLocaleString('en-US', { style: 'currency', currency: 'USD'}) || "$0")}
                            </div>
                          </div>
                        </div>
                        <div className='flex justify-between mx-3 border-black border-t pt-6 pb-2'>
                            <div className='font-semibold text-xl pl-3'>Average Yearly Total Compensation: </div>
                            <div className='font-semibold text-xl pr-3'>
                              {(offer.salaryDetails.baseSalary + offer.salaryDetails.stock + offer.salaryDetails.targetBonus).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                            </div>
                        </div>
                      </>
                    )}
                    
                    
                  </div>
            ))}
            {/* <div className='border-black border-4 border-double mx-3'> */}
              <div className="text-3xl pb-2 mt-6 mb-3 px-2 border-black border-b mx-3">Additional Details</div> 
              {/* <div className='border-black border-[0.5px] mx-2'></div> */}
              {/* <div className="bg-white max-w-screen-md"> */}
              <div className='p-5'>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(jobOffer.additionalContent) }} />
              </div>
            {/* </div> */}
            
                
            {/* </div> */}
            <div className='inline-flex justify-between items-center w-full ml-2 border-black border-b-2'>
              <div className=''>
                  <button onClick={toggleLike} className='inline-flex items-center mr-4 mt-1 p-2 text-2xl'>
                    <div className='mr-2 flex items-center'>
                      {likedByMe ? (
                        <i class="fa-solid fa-hands-clapping"></i>
                      ) : ( 
                        
                          <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  width="19.000000pt" height="20.000000pt" viewBox="0 0 300.000000 296.000000"  preserveAspectRatio="xMidYMid meet">  <g transform="translate(0.000000,296.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"> <path d="M1810 2918 c-47 -25 -50 -47 -48 -276 3 -211 3 -214 27 -233 31 -26 95 -25 121 1 29 29 31 49 28 268 -3 186 -5 203 -23 222 -26 26 -74 34 -105 18z"/> <path d="M1272 2825 c-34 -15 -52 -42 -52 -79 0 -29 186 -315 221 -340 56 -39 129 0 129 69 0 28 -20 65 -99 183 -54 81 -104 152 -112 158 -24 19 -55 22 -87 9z"/> <path d="M2370 2833 c-30 -11 -60 -48 -150 -183 -105 -159 -115 -194 -66 -236 32 -28 72 -31 105 -8 35 25 221 311 221 340 0 38 -18 64 -55 80 -19 8 -36 14 -37 13 -2 0 -10 -3 -18 -6z"/> <path d="M838 2237 c-65 -19 -121 -58 -158 -112 l-31 -46 -30 26 c-43 35 -130 59 -187 50 -104 -15 -176 -67 -221 -157 -36 -71 -41 -148 -15 -225 12 -34 13 -48 5 -51 -38 -13 -99 -74 -126 -127 -25 -49 -30 -70 -30 -129 0 -87 29 -146 110 -226 l54 -53 -43 -29 c-52 -34 -92 -89 -112 -154 -18 -61 -18 -98 2 -163 14 -48 36 -74 253 -297 130 -134 268 -268 306 -299 193 -154 482 -236 720 -205 416 55 735 331 842 727 l27 98 4 456 c2 308 0 470 -7 497 -19 68 -70 134 -131 167 -47 26 -65 30 -130 30 -175 -1 -270 -115 -270 -324 l0 -85 -302 300 c-189 187 -317 307 -341 318 -51 23 -131 29 -189 13z m115 -178 c12 -6 191 -179 397 -385 336 -334 379 -374 407 -374 19 0 43 10 60 24 l28 24 5 227 c5 223 5 227 29 246 35 28 96 25 127 -6 l25 -25 -3 -453 c-5 -510 -4 -508 -83 -672 -101 -209 -292 -366 -520 -427 -122 -32 -300 -30 -420 6 -96 29 -190 76 -263 132 -75 57 -492 464 -509 497 -18 35 -12 90 13 118 26 28 76 42 110 29 16 -6 86 -67 155 -136 114 -112 129 -124 161 -124 28 0 42 7 62 31 54 64 54 64 -244 364 -258 259 -270 273 -270 309 0 54 52 106 106 106 36 0 50 -11 294 -254 140 -139 266 -261 280 -270 35 -23 64 -20 99 10 24 20 31 34 31 62 0 34 -19 55 -335 372 -318 319 -335 338 -335 373 0 52 18 84 57 102 68 32 72 29 433 -331 365 -363 359 -359 419 -308 24 20 31 34 31 62 0 35 -13 51 -231 267 -127 127 -237 242 -245 257 -46 88 44 190 129 147z"/> <path d="M2590 2011 c-76 -23 -136 -78 -172 -156 -21 -46 -23 -66 -26 -276 l-4 -227 36 -27 c30 -23 43 -27 73 -22 67 11 67 13 73 263 l5 226 28 24 c37 32 87 32 124 0 l28 -24 0 -439 c-1 -419 -2 -442 -23 -526 -73 -290 -294 -515 -576 -587 -72 -18 -85 -26 -140 -78 -34 -32 -80 -71 -103 -87 -24 -15 -40 -31 -37 -36 13 -21 241 2 362 37 275 79 514 299 625 574 62 156 67 206 67 710 0 436 -1 457 -21 500 -54 119 -198 187 -319 151z"/> </g> </svg>                       

                      )}
                    </div>
                      {jobOffer.likes}
                  </button>
                  
                  
              </div>
              <div className='mr-5'>
                  <div className='inline-flex text-xl pt-1 mr-4'>
                    <div className=''>
                      {/* <i class="fa-solid fa-bookmark"></i> */}
                      <button onClick={(e) => toggleBookmark(jobOffer._id, e)}>
                          {bookmarks?.has(jobOffer?._id.toString()) ? <i class="fa-solid fa-bookmark"></i> : <i class="fa-regular fa-bookmark"></i>}
                      </button>
                    </div> 
                  </div>
                  <div className='inline-flex text-xl pt-1'>
                    <div className=''>
                      <i class="fa-solid fa-arrow-up-from-bracket"></i>
                    </div> 
                  </div>
              </div>
            </div>

            
          </div>
          <section class='max-w-screen-md mx-auto items-center justify-center m-4 px-2'>
            {/* <div className='justify-between inline-flex'>
              <div className='text-xl'>
                Comments/Discussion ({jobOffer.commentCount})
              </div>
              <select onChange={(e) => setSort(e.target.value)} className='bg-black text-white rounded px-3 py-1'>
                <option value="latest">Latest</option>
                <option value="oldest">Oldest</option>
              </select>
            </div> */}
            <div className='justify-between flex'>
              <div className='text-xl'>
                Comments/Discussion ({jobOffer.commentCount})
              </div>
              <select onChange={(e) => setSort(e.target.value)} className='bg-black text-white rounded px-3 py-1 text-sm'>
                <option value="latest">Latest</option>
                <option value="oldest">Oldest</option>
              </select>
            </div>   
            <textarea
              value={newComment}
              onChange={e => setNewComment(e.target.value)}
              placeholder="Write a comment..."
              className='w-full mt-4 rounded py-1 bg-white focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px] overflow-y-auto resize-none'
              rows="1"
            />
            <button onClick={addComment} className='mt-2 rounded bg-black text-white py-1 px-3 text-sm'>Add Comment</button>

            {jobOffer.comments.map((comment) => (
              <Comment key={comment._id} comment={comment} documentId={documentId} isRoot={true} />
            ))}
          </section>
          {/* <div className='max-w-screen-md mx-auto items-center inline-flex justify-between m-4'>
            
            <select onChange={(e) => setSort(e.target.value)} className='bg-black text-white rounded px-3 py-1'>
              <option value="latest">Latest</option>
              <option value="oldest">Oldest</option>
            </select>
          </div> */}
          
          {/* <h1></h1> */}
          
          
          
        </div>
      ) : <p>Loading job offer details...</p>}
    </div>
  );
}

export default JobOfferDetails;

  // const addComment = () => {
  //   axios.post(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments?sort=${sort}`, {
  //     text: newComment,
  //     commenter: 'Anonymous'
  //   })
  //   .then(response => {
  //     // Assuming response.data is the updated job offer with the new comment list
  //     setJobOffer(response.data);
  //     setNewComment("");
  //   })
  //   .catch(error => console.error('Error posting comment:', error));
  // };
  // const addComment = () => {
  //   axios.post(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments`, {
  //     text: newComment,
  //     commenter: 'Anonymous'
  //   })
  //   .then(response => {
  //     setJobOffer(prevJobOffer => ({
  //       ...prevJobOffer,
  //       comments: [...prevJobOffer.comments, response.data]  // Assuming response.data is the new comment
  //     }));
  //     setNewComment("");
  //   })
  //   .catch(error => console.error('Error posting comment:', error));
  // };


            {/* <pre>{JSON.stringify(jobOffer, null, 2)}</pre> */}

          {/* <h3>Comments</h3> */}
          {/* <h3>Comments ({jobOffer.comments.length})</h3> */}
          {/* <h3>{jobOffer.likes} Likes</h3> */}
          {/* <button onClick={toggleLike}>
            {likedByMe ? 'Unlike' : 'Like'}
          </button> */}

// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';
// import Comment from './Comment';

// function JobOfferDetails() {
//   const { documentId } = useParams();
//   const [jobOffer, setJobOffer] = useState(null);
//   const [newComment, setNewComment] = useState("");
//   const [sort, setSort] = useState('latest'); // Default sort by latest

//   useEffect(() => {
//     // Fetch job offer details
//     axios.get(`https://api.finaloffers.fyi/jobOffers/view/${documentId}`)
//       .then(response => {
//         setJobOffer(response.data);
//       })
//       .catch(error => console.error('Error fetching job offer:', error));

//     // Fetch sorted comments separately
//     fetchComments();
//   }, [documentId, sort]);

//   const fetchComments = () => {
//     axios.get(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments?sort=${sort}`)
//       .then(response => {
//         if (jobOffer) {
//           setJobOffer({ ...jobOffer, comments: response.data });
//         } else {
//           // In case jobOffer is not yet set
//           setJobOffer({ comments: response.data });
//         }
//       })
//       .catch(error => console.error('Error fetching comments:', error));
//   };

//   const addComment = () => {
//     axios.post(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments`, {
//       text: newComment,
//       commenter: 'Anonymous'
//     })
//     .then(response => {
//       setJobOffer(prev => ({ ...prev, comments: [...prev.comments, response.data] }));
//       setNewComment("");
//     })
//     .catch(error => console.error('Error posting comment:', error));
//   };

//   const handleSortChange = (newSort) => {
//     setSort(newSort);
//   };

//   return (
//     <div>
//       {jobOffer ? (
//         <div>
//           <pre>{JSON.stringify(jobOffer, null, 2)}</pre>
//           <div>
//             <button onClick={() => handleSortChange('latest')}>Sort by Latest</button>
//             <button onClick={() => handleSortChange('oldest')}>Sort by Oldest</button>
//             <h3>Comments</h3>
//             {jobOffer.comments.map((comment) => (
//               <Comment key={comment._id} comment={comment} documentId={documentId} />
//             ))}
//             <input
//               type="text"
//               value={newComment}
//               onChange={e => setNewComment(e.target.value)}
//               placeholder="Write a comment..."
//             />
//             <button onClick={addComment}>Add Comment</button>
//           </div>
//         </div>
//       ) : <p>Loading job offer details...</p>}
//     </div>
//   );
// }

// export default JobOfferDetails;

// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';
// import Comment from './Comment';

// function JobOfferDetails() {
//   const { documentId } = useParams();
//   const [jobOffer, setJobOffer] = useState(null);
//   const [newComment, setNewComment] = useState("");

//   useEffect(() => {
//     axios.get(`https://api.finaloffers.fyi/jobOffers/view/${documentId}`)
//       .then(response => setJobOffer(response.data))
//       .catch(error => console.error('Error fetching job offer:', error));
//   }, [documentId]);

//   const addComment = () => {
//     axios.post(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments`, {
//       text: newComment,
//       commenter: 'Anonymous' // This should be replaced with the actual user's name or ID
//     })
//     .then(response => {
//       setJobOffer(prev => ({ ...prev, comments: [...prev.comments, response.data] }));
//       setNewComment("");
//     })
//     .catch(error => console.error('Error posting comment:', error));
//   };

//   return (
//     <div>
//       {jobOffer ? (

//         <div>
//             <pre>{JSON.stringify(jobOffer, null, 2)}</pre>
//           <h3>Comments</h3>
//           {jobOffer.comments.map((comment) => (
//             <Comment key={comment._id} comment={comment} documentId={documentId} />
//           ))}
//           <input
//             type="text"
//             value={newComment}
//             onChange={e => setNewComment(e.target.value)}
//             placeholder="Write a comment..."
//           />
//           <button onClick={addComment}>Add Comment</button>
//         </div>
//       ) : <p>Loading job offer details...</p>}
//     </div>
//   );
// }

// export default JobOfferDetails;

// ==================================================================
// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';

// function JobOfferDetails() {
//   const { documentId } = useParams();
//   const [jobOffer, setJobOffer] = useState(null);
//   const [newComment, setNewComment] = useState("");

//   useEffect(() => {
//     axios.get(`https://api.finaloffers.fyi/jobOffers/view/${documentId}`)
//       .then(response => setJobOffer(response.data))
//       .catch(error => console.error('Error fetching job offer:', error));
//   }, [documentId]);

//     const addComment = () => {
//         axios.post(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments`, {
//         text: newComment,
//         commenter: 'Anonymous' // This should be replaced with the actual user's name or ID
//         })
//         .then(response => {
//         setJobOffer(response.data); // Update the job offer with the new comment
//         setNewComment(""); // Clear the input after submission
//         })
//         .catch(error => console.error('Error posting comment:', error));
//     };

//   const handleVote = (commentId, type) => {
//     axios.post(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments/${commentId}/${type}`)
//       .then(response => {
//         setJobOffer(response.data); // Update the job offer with the new votes
//       })
//       .catch(error => console.error(`Error ${type}voting comment:`, error));
//   };

//   return (
//     <div>
//       {jobOffer ? (
//         <div>
//           <pre>{JSON.stringify(jobOffer, null, 2)}</pre>
//           <div>
//             <h3>Comments</h3>
//             {jobOffer.comments.map((comment, index) => (
//               <div key={index}>
//                 <p>{comment.text} - by {comment.commenter}</p>
//                 <button onClick={() => handleVote(comment._id, 'upvote')}>Upvote ({comment.upvotes})</button>
//                 {/* {comment.upvotes - comment.downvotes} */}
//                 <button onClick={() => handleVote(comment._id, 'downvote')}>Downvote ({comment.downvotes})</button>
//                 <p>Effective Votes: {comment.netVotes}</p>
//               </div>
//             ))}
//             <input
//               type="text"
//               value={newComment}
//               onChange={e => setNewComment(e.target.value)}
//             />
//             <button onClick={addComment}>Add Comment</button>
//           </div>
//         </div>
//       ) : <p>Loading job offer details...</p>}
//     </div>
//   );
// }

// export default JobOfferDetails;
//=========================================================================
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useParams } from 'react-router-dom';

// function JobOfferDetails() {
//   const { documentId } = useParams();
//   const [jobOffer, setJobOffer] = useState(null);
//   const [newComment, setNewComment] = useState("");
  
//   useEffect(() => {
//     axios.get(`https://api.finaloffers.fyi/jobOffers/view/${documentId}`)
//       .then(response => setJobOffer(response.data))
//       .catch(error => console.error('Error fetching job offer:', error));
//   }, [documentId]);

//   const addComment = () => {
//     axios.post(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments`, {
//       text: newComment,
//       commenter: 'Anonymous' // This should be replaced with the actual user's name or ID
//     })
//     .then(response => {
//       setJobOffer(response.data); // Update the job offer with the new comment
//       setNewComment(""); // Clear the input after submission
//     })
//     .catch(error => console.error('Error posting comment:', error));
//   };

//   return (
//     <div>
//       {jobOffer ? (
//         <div>
//           <pre>{JSON.stringify(jobOffer, null, 2)}</pre>
//           <div>
//             <h3>Comments</h3>
//             <ul>
//               {jobOffer.comments.map((comment, index) => (
//                 <li key={index}>{comment.text} - by {comment.commenter}</li>
//               ))}
//             </ul>
//             <input
//               type="text"
//               value={newComment}
//               onChange={e => setNewComment(e.target.value)}
//             />
//             <button onClick={addComment}>Add Comment</button>
//           </div>
//         </div>
//       ) : <p>Loading job offer details...</p>}
//     </div>
//   );
// }

// export default JobOfferDetails;


// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';

// function JobOfferDetails() {
//     const { documentId } = useParams(); // Retrieve the document ID from the URL
//     const [jobOffer, setJobOffer] = useState(null);
  
//     // Log the documentId to check if it's being received correctly
//     console.log("Received documentId:", documentId);
  
//     // useEffect(() => {
//     //   // Log the URL being called to ensure it's formed correctly
//     //   console.log(`Attempting to fetch data from: https://api.finaloffers.fyi/jobOffer/view/${documentId}`);
//     //   axios.get(`https://api.finaloffers.fyi/jobOffer/view/${documentId}`)
//     //     .then(response => {
//     //       console.log("Job offer data received:", response.data); // Log the data received
//     //       setJobOffer(response.data); // Set the fetched data to state
//     //     })
//     //     .catch(error => {
//     //       console.error('Error fetching job offer:', error);
//     //     });
//     // }, [documentId]);

//     useEffect(() => {
//         // Ensure logging occurs at the start of the useEffect
//         console.log(`Preparing to fetch data from: https://api.finaloffers.fyi/jobOffer/view/${documentId}`);
      
//         // Make sure to handle any potential errors in URL formation or other operations
//         try {
//           const url = `https://api.finaloffers.fyi/jobOffers/view/${documentId}`;
//           console.log(`Making API call to: ${url}`);
//           axios.get(url)
//             .then(response => {
//               console.log("Job offer data received:", response.data); // Log the data received
//               setJobOffer(response.data); // Set the fetched data to state
//             })
//             .catch(error => {
//               console.error('Teri maa ki chut:', error);
//             });
//         } catch (error) {
//           console.error('Error preparing for API call:', error);
//         }
//       }, [documentId]);
      
  
//     return (
//       <div>
//         {jobOffer ? (
//           <pre>{JSON.stringify(jobOffer, null, 2)}</pre> // Display the job offer details
//         ) : (
//           <p>Loading job offer details...</p>
//         )}
//       </div>
//     );
//   }



// function JobOfferDetails() {
//   const { documentId } = useParams(); // Retrieve the document ID from the URL
//   const [jobOffer, setJobOffer] = useState(null);

//   // Modify the axios.get call to use a path parameter
//     useEffect(() => {
//         console.log({documentId});
//         axios.get(`https://api.finaloffers.fyi/jobOffer/view/${documentId}`)
//         .then(response => {
//             setJobOffer(response.data); // Set the fetched data to state
//         })
//         .catch(error => {
//             console.error('Error fetching job offer:', error);
//         });
//     }, [documentId]);

//   return (
//     <div>
//       {jobOffer ? (
//         <pre>{JSON.stringify(jobOffer, null, 2)}</pre> // Display the job offer details
//       ) : (
//         <p>Loading job offer details...</p>
//       )}
//     </div>
//   );
// }

// export default JobOfferDetails;
